import { HOUR_PRESETS } from './constants';
export const convertToHours = (value, unit) => {
    switch (unit) {
        case 'hours':
            return value;
        case 'days':
            return value * 24;
        default:
            return value;
    }
};
export const parseHoursToState = (data) => {
    const presetMatch = HOUR_PRESETS.find((p) => parseInt(p) === data.hours);
    if (presetMatch) {
        return {
            enabled: data.enabled,
            duration: presetMatch,
            customValue: 1,
            customUnit: 'days',
        };
    }
    if (data.hours % 24 === 0) {
        return { enabled: data.enabled, duration: 'custom', customValue: data.hours / 24, customUnit: 'days' };
    }
    return { enabled: data.enabled, duration: 'custom', customValue: data.hours, customUnit: 'hours' };
};
export const stateToHours = (state) => {
    if (state.duration === 'custom') {
        return convertToHours(state.customValue, state.customUnit);
    }
    return parseInt(state.duration);
};
